import {
  DealPriorityComboboxPopover,
  type DealPriorityComboboxPopoverProps,
} from './deal-priority-combobox-popover';

// DEV NOTE: this is just a wrapper around the DealPrioritySelector component
// that is used to make the button look like a button
export function DealPrioritySelectorButton(
  props: DealPriorityComboboxPopoverProps,
) {
  return (
    <div className="p-0 h-fit border rounded-md">
      <DealPriorityComboboxPopover {...props} />
    </div>
  );
}
